const TweenLite = require('gsap')
const ScrollToPlugin = require('gsap/ScrollToPlugin')
const Barba = require('barba.js')
require('lity')

const PixiCarousel = require('pixi-responsive-carousel/PixiCarousel')

document.addEventListener('DOMContentLoaded', function() {

  // ## Pixi Carousel ##
  const pixiCarousel = new PixiCarousel(params)
  // Expand Listener -> Handle click on a already on marker
  pixiCarousel.domContainer.addEventListener('removeExpand', () => {
    document.body.classList.remove('expanded-carousel')
    pixiCarousel.hideMarkers()
  })

  // Menu On Off
  let navAdded = false
  document.querySelector('#trigger-nav').addEventListener('click', (e) => {
    e.preventDefault()
    navAdded = toggleClass(document.body, 'nav-on')
    if(navAdded) { // Si la classe a été ajoutée 
      TweenLite.to(window, 0.6, {scrollTo:{ y: 0 }, ease:Power4.easeInOut})
    }
  })

  // Contact On Off
  let contactAdded = false
  const contactTriggers = Array.prototype.slice.call(document.querySelectorAll('.trigger-contact'))
  contactTriggers.map(contactTrigger => { // Plusieurs trigger contact
    contactTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      contactAdded = toggleClass(document.body, 'contact-on')
      if(contactAdded) {
        if( $( 'body' ).hasClass( 'nav-on' ) ){ $( 'body' ).removeClass( 'nav-on' ); }
        if( $( 'body' ).hasClass( 'suivez-on' ) ){ $( 'body' ).removeClass( 'suivez-on' ); }
        if( $( 'body' ).hasClass( 'rens-on' ) ){ $( 'body' ).removeClass( 'rens-on' ); }
        pixiCarousel.hideMarkers()
      }else{
        pixiCarousel.showMarkers()
      }
    })
  })  

  // Rens On Off
  let rensAdded = false
  const rensTriggers = Array.prototype.slice.call(document.querySelectorAll('.trigger-rens'))
  rensTriggers.map(rensTrigger => { // Plusieurs trigger rens
    rensTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      rensAdded = toggleClass(document.body, 'rens-on')
      if(rensAdded) {
        if( $( 'body' ).hasClass( 'suivez-on' ) ){ $( 'body' ).removeClass( 'suivez-on' ); }
        if( $( 'body' ).hasClass( 'contact-on' ) ){ $( 'body' ).removeClass( 'contact-on' ); }
      }
    })
  })  

  // Suivez On Off
  let suivezAdded = false
  const suivezTriggers = Array.prototype.slice.call(document.querySelectorAll('.trigger-reseaux'))
  suivezTriggers.map(suivezTrigger => { // Plusieurs trigger contact
    suivezTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      suivezAdded = toggleClass(document.body, 'suivez-on')
      if(suivezAdded) {
        if( $( 'body' ).hasClass( 'rens-on' ) ){ $( 'body' ).removeClass( 'rens-on' ); }
        if( $( 'body' ).hasClass( 'contact-on' ) ){ $( 'body' ).removeClass( 'contact-on' ); }
        pixiCarousel.hideMarkers()
      }else{
        pixiCarousel.showMarkers()
      }
    })
  }) 

  // Back carousel
  document.querySelector('#carousel #back').addEventListener('click', expandCarousel)

  function expandCarousel() {
    document.body.classList.add('expanded-carousel')
    if( $( 'body' ).hasClass( 'rens-on' ) ){ $( 'body' ).removeClass( 'rens-on' ); }
    if( $( 'body' ).hasClass( 'suivez-on' ) ){ $( 'body' ).removeClass( 'suivez-on' ); }
    pixiCarousel.showMarkers()
  }

  // Actus slider
  const actusSlide = tns({
    container: '.slider-actus',
    items: 1,
    controls: false,
    axis: 'vertical',
    speed: 400,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayButtonOutput: false
  });

  // NAV AJAX BARBA
  const transition_speed = 400
  const transition = Barba.BaseTransition.extend({
    start: function() {
      if( $( 'body' ).hasClass( 'nav-on' ) ){ $( 'body' ).removeClass( 'nav-on' ); }
      if( $( 'body' ).hasClass( 'expanded-carousel' ) ){ $( 'body' ).removeClass( 'expanded-carousel' ); }
      if( $( 'body' ).hasClass( 'contact-on' ) ){ $( 'body' ).removeClass( 'contact-on' ); }
      TweenLite.to(window, 0.6, {scrollTo:{ y: 0 }, ease:Power4.easeInOut})
      Promise
        .all( [this.pageOut(), this.newContainerLoading] )
        .then( this.pageIn.bind( this ) );
    },
    pageOut: function() {
      var deferred = Barba.Utils.deferred();
      $( 'body' ).addClass( 'transition-page-out' );
      setTimeout( function() {
        deferred.resolve();
      }, transition_speed );
      return deferred.promise;
    },
    pageIn: function(){
      $( 'html, body' ).scrollTop( 0 );
      $( 'body' ).addClass( 'transition-page-in' );
      setTimeout( function() {
        $( 'body' ).removeClass( 'transition-page-out' ).removeClass( 'transition-page-in' );
      }, transition_speed );
      this.done();
    }
  })

  Barba.Pjax.getTransition = function() {
		return transition;
  };


  const indexView = Barba.BaseView.extend({
    namespace: 'index',
    onEnterCompleted: function() {
      $( 'body' ).addClass('home');
      if(Barba.HistoryManager.history.length == 1){ // Si on arrive via la pahe index
        pixiCarousel.markersHided = false
      }else{
        if(pixiCarousel.markersHided){ pixiCarousel.showMarkers() }
      }
    },
    onLeave: function() {
      $( 'body' ).removeClass('home');
      if(!pixiCarousel.markersHided){ pixiCarousel.hideMarkers() }
    }
  });
  indexView.init();

  const pageView = Barba.BaseView.extend({
    namespace: 'page',
    onEnterCompleted: function() {
      $( 'body' ).addClass('page');
      $( '.close-link' ).on('click', expandCarousel)
      $( '.gallery a' ).addClass('no-barba shadow');
      $( '.gallery a' ).attr('data-lity', 1);
    },
    onLeave: function() {
      $( 'body' ).removeClass('page');
      if(!pixiCarousel.markersHided){ pixiCarousel.hideMarkers() }
    }
  });
  pageView.init();

  Barba.Pjax.init()

	Barba.Dispatcher.on( 'newPageReady', function( currentStatus, oldStatus, container ) {
    barba_cssimg_ajax(container);
    basic(container);
  } );
  
  function basic(container) {

    $(container).find('.trigger-rens').on('click', function(e) {
      e.preventDefault()
      contactAdded = toggleClass(document.body, 'rens-on')
    });

  }

  /* GMAP */
  var style = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#193341"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#2c5a71"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#29768a"},{"lightness":-37}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#406d80"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#406d80"}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#3e606f"},{"weight":2},{"gamma":0.84}]},{"elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"weight":0.6},{"color":"#1a3541"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#2c5a71"}]}];
  var lat_lng = {lat: 46.976683, lng: -1.806190};
  var map = new google.maps.Map( document.getElementById('map'), {
    center: lat_lng,
    styles: style,
    zoom: 6,
    scrollwheel: false,
  } );
  var marker = new google.maps.Marker( {
    position: lat_lng,
    map: map,
    icon: pointer,
  } );

  // Info window
  let infoWindow = new google.maps.InfoWindow();
  const infoContent = $( '.contact-infos' ).html();
  infoWindow.setContent( '<div style="padding-left: 18px;">' + infoContent + '</div>' );
  infoWindow.open(map, marker);

  // Info window events
	google.maps.event.addListener(map, 'click', function(event) {
		infoWindow.close();
  });
  marker.addListener('click', function() {
    infoWindow.open(map, marker);
  });

});

function toggleClass(el, _class) {
  if (el && el.className && el.className.indexOf(_class) >= 0) {
    el.classList.remove(_class)
    return false
  }else{
    el.classList.add(_class)
    return true
  }
}
